import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { PlusIcon } from "lucide-react";
import { ROUTES } from "@/constants/routes";
import { NavLink } from "react-router-dom";

const AboutPageHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.about.list")}</h1>
      <NavLink to={ROUTES.ABOUT_CREATE}>
        <Button>
          <PlusIcon />
          <span className="hidden sm:inline">
            {t("modules.about.keys.add_about")}
          </span>
        </Button>
      </NavLink>
    </div>
  );
};

export default AboutPageHeader;
